import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../lib/cn';

const badgeStyles = cva('inline-flex items-center gap-1 font-medium whitespace-nowrap', {
  variants: {
    tone: {
      neutral: 'bg-bg-subtle text-fg-primary',
      accent: 'bg-accent text-accent-fg',
      success: 'bg-success/15 text-success',
      warning: 'bg-warning/15 text-warning',
      danger: 'bg-danger/15 text-danger',
      info: 'bg-info/15 text-info',
      outline: 'border border-border-subtle text-fg-secondary',
    },
    size: {
      sm: 'h-5 px-1.5 text-xs',
      md: 'h-6 px-2 text-xs',
      lg: 'h-7 px-2.5 text-sm',
    },
    shape: {
      rounded: 'rounded-md',
      pill: 'rounded-full',
    },
  },
  defaultVariants: { tone: 'neutral', size: 'md', shape: 'rounded' },
});

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeStyles> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { className, tone, size, shape, ...props },
  ref,
) {
  return (
    <span ref={ref} className={cn(badgeStyles({ tone, size, shape }), className)} {...props} />
  );
});
